// import React from "react";
// import {
//   Button,
//   DropdownMenu,
//   NewTable,
//   SmartTooltip,
// } from "../../../../../../components";
// import { formatNumber, mapTableRows } from "../../../../../../utils";

// const FinalizedEmployees = () => {
//   const handleEdit = (row) => {
//     console.log(row);
//   };
//   const handleDelete = (row) => {
//     console.log(row);
//   };
//   const handleView = (row) => {
//     console.log(row);
//   };
//   const handleDownload = (row) => {
//     console.log(row);
//   };

//   const tableData = [
//     {
//       employeeName: "Abdul Waseem Syed",
//       employeeID: "EMP-1001",
//       employeeCategory: "W2",
//       salaryType: "Hourly",
//       lcaMonthly: "$ 7673.50",
//       timesheets: "$ 8332.80",
//       expenses: "$ 0.00",
//       deductions: "$ 692.86",
//       healthInsurance: "$ 0.00",
//       adjustmentPayments: " 100.00",
//       perDiem: "$ 0.00",
//       commision: "$ 0.00",
//       total: "$ 7673.50",
//     },
//   ];
//   const columns = [
//     { key: "employeeName", label: "Employee Name" },
//     { key: "employeeID", label: "Employee ID" },
//     { key: "employeeCategory", label: "Employee Category" },
//     { key: "salaryType", label: "Salary Type" },
//     { key: "lcaMonthly", label: "LCA Monthly" },
//     { key: "timesheets", label: "Timesheets" },
//     { key: "expenses", label: "Expenses" },
//     { key: "deductions", label: "Deductions" },
//     { key: "healthInsurance", label: "Health Insurance" },
//     {
//       key: "adjustmentPayments",
//       label: "Adjustment Payments",
//       render: (row) => {
//         const isNegative = row.adjustmentPayments.includes("-");
//         return (
//           <span className={isNegative ? "text-danger" : "text-success"}>
//             $ {formatNumber(row.adjustmentPayments)}
//           </span>
//         );
//       },
//     },
//     { key: "perDiem", label: "Per Diem" },
//     { key: "commision", label: "Commision" },
//     { key: "total", label: "Total" },
//     {
//       key: "action",
//       label: "Action",
//       sortable: false,
//       render: (row) => (
//         <div className="flex gap-2">
//           <Button
//             type="icon"
//             variant="text"
//             icon="published_with_changes"
//             size="xs"
//             onClick={() => handleEdit(row)}
//           />
//           <Button
//             type="icon"
//             variant="text"
//             icon="guardian"
//             size="xs"
//             onClick={() => handleDelete(row)}
//           />
//           <Button
//             type="icon"
//             variant="text"
//             icon="body_system"
//             size="xs"
//             onClick={() => handleView(row)}
//           />
//           <Button
//             type="icon"
//             variant="text"
//             icon="history"
//             size="xs"
//             onClick={() => handleDownload(row)}
//           />
//         </div>
//       ),
//     },
//   ];

//   const mappedRows = mapTableRows(tableData, columns);
//   return (
//     <NewTable
//       fixedCol={1}
//       showCheckbox
//       rows={mappedRows}
//       columns={columns}
//       toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
//       customSection={
//         <div className="flex gap-2 ml-1">
//           <Button title={"Search"} size="sm" />
//                     <Button title={"Revert"} size="sm" icon={"add"} iconPosition="before"/>

//           {/* <Button title={"Add Exit  Employee"} size="sm" icon="add" />
//           <Button title={"Update Employees Paydata"} size="sm" /> */}
//           <DropdownMenu
//             MenuSection={
//               <div className="flex flex-col">
//                 <Button
//                   title={"EXCEL"}
//                   variant="text"
//                   color="black"
//                   size="xs-sm"
//                   className="!justify-start py-1"
//                 />
//                 <Button
//                   title={"CSV"}
//                   variant="text"
//                   color="black"
//                   size="xs-sm"
//                   className="!justify-start py-1"
//                 />
//               </div>
//             }
//           >
//             <Button
//               color="black"
//               title=""
//               size="md"
//               icon={"screen_share"}
//               variant="text"
//             />
//           </DropdownMenu>
//         </div>
//       }
//     />
//   );
// };

// export default FinalizedEmployees;

import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Drawer,
  DropdownMenu,
  TableAdv,
  showToast,
  SmartTooltip,
  ToolTip,
} from "../../../../../../components";
import {
  formatNumber,
  getEmployeeId,
  mapTableRows,
} from "../../../../../../utils";
import qb from "../../../../../../assets/qb.svg";
import FinalizeModal from "../Modals/FinalizeModal";
import ProposedEmployeesDetails from "./ProposedEmployeesDetails/ProposedEmployeesDetails";
import { totalCountStart } from "../../../../../../redux/slices/totalCount/totalCountSlice";
import {
  clearCurrentPayrollEditing,
  clearEmpPayConfigMain,
  clearPayroll,
  getAllEmpPayConfigsStart,
  getAllPayrollStart,
  updatePayrollStart,
} from "../../../../../../redux/slices/payroll/payrollSlice";
import { usePagination } from "../../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency } from "../../../../../../utils/stringUtils";
import { WORKFORCE_API_URL } from "../../../../../../redux/apiConfig";
import axios from "axios";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";

const FinalizedEmployees = ({ configData }) => {
  const { userData: loginUserData } = useLoginUser();
  const dispatch = useDispatch();
  const { payroll: ProposedEmployees, loading } =
    useSelector((state) => state.payRoll) || {};
  const { value } = useSelector((state) => state.totalCount);
  const [searchQuery, setSearchQuery] = useState("");

  const isAggregate = !!ProposedEmployees?.data?.[0]?.data;
  const dataArray = isAggregate ? ProposedEmployees.data[0].data : (ProposedEmployees?.data || []);
  const totalCount = isAggregate ? (ProposedEmployees?.data?.[0]?.count?.[0]?.total || 0) : value?.payrolls?.data;
  
  const [forceRender, setForceRender] = useState(false);
  const [totalPayAmount, setTotalPayAmount] = useState(0);

  const forceRerender = () => {
    setForceRender((prev) => !prev);
  };

  const handleSearch = (key, val) => {
    setSearchQuery(val);
    setPage(1);
  };

  const fetchPayrolls = () => {
    let payload = { coll: "Payroll", limit: limit, page: page };
    if (searchQuery) {
      payload.useAggregate = true;
      payload.filters = {
        payDayEmployeesSearch: {
          type: "AG_LOOKUP_DATA",
          value: [
            searchQuery,
            configData?.salaryProfileId?.uiid,
            configData?.payCycle?.from,
            configData?.payCycle?.to,
            2
          ]
        }
      };
    } else {
      payload.ref = "Employee SalProfile PayConfig InsuranceDed RegularDed ShortPay ExcessPay";
      payload.filters = {
        status: { type: "NONE", value: 2 },
        "payCycle.from": { type: "GTE", value: configData?.payCycle?.from },
        "payCycle.to": { type: "LTE", value: configData?.payCycle?.to },
        salaryProfileId: { type: "NONE", value: configData?.salaryProfileId?.uiid },
      };
    }
    dispatch(getAllPayrollStart(payload));
    if (!searchQuery) {
      dispatch(totalCountStart({ collection: "payrolls", coll: "Payroll", filters: payload.filters }));
    }
  };

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  useEffect(() => {
    fetchPayrolls();
    return () => {
      dispatch(clearPayroll());
    };
  }, [dispatch, limit, page, forceRender, searchQuery, configData]);
  const [FinalizeModalOpen, setFinalizeModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleEdit = (row) => {
    console.log(row);
  };
  const handleDelete = (row) => {
    console.log(row);
  };
  const handleView = (row) => {
    console.log(row);
  };
  const handleDownload = (row) => {
    console.log(row);
  };

  const tableData = [
    {
      employeeName: "Abdul Waseem Syed",
      employeeID: "EMP-12345",
      employeeCategory: "W2",
      salaryType: " Hourly",
      lcaMonthly: "7673.50",
      timesheets: "8332.80",
      expenses: "0.00",
      deductions: "692.86",
      healthInsurance: "0.00",
      adjustmentPayments: "100.00",
      perDiem: "0.00",
      commision: "0.00",
      total: "7639.94",
      info: "Please check the payment details and save the Paystub to process further",
    },
    // {
    //   employeeName: "Abubakar Mohammed",
    //   employeeID: "EMP-12345",
    //   employeeCategory: "W2",
    //   salaryType: " Hourly",
    //   lcaMonthly: "1693.96",
    //   timesheets: " 0.00",
    //   expenses: " 0.00",
    //   deductions: "692.86",
    //   healthInsurance: "1362.70",
    //   adjustmentPayments: "-200.00",
    //   perDiem: "0.00",
    //   commision: " 0.00",
    //   total: "7639.94",
    // },
    // {
    //   employeeName: "Aishwarya Vedula",
    //   employeeID: "EMP-12345",
    //   employeeCategory: "",
    //   salaryType: " Hourly",
    //   lcaMonthly: "7673.50",
    //   timesheets: "8320.00",
    //   expenses: "0.00",
    //   deductions: "183.50",
    //   healthInsurance: " 0.00",
    //   adjustmentPayments: "100.00",
    //   perDiem: "0.00",
    //   commision: " 0.00",
    //   total: "7639.94",
    //   info: "Please check the payment details and save the Paystub to process further",
    // },
  ];
  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
      width:"min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        const employeeName =
          row?.employeeId?.firstName && row?.employeeId?.lastName
            ? `${row?.employeeId?.firstName
                .charAt(0)
                .toUpperCase()}${row?.employeeId?.firstName.slice(
                1,
              )} ${row?.employeeId?.lastName
                .charAt(0)
                .toUpperCase()}${row?.employeeId?.lastName.slice(1)}`
            : "-";
        return (
          <SmartTooltip
            description={employeeName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <span
              className="cursor-pointer text-info line-clamp-1"
              onClick={() => {
                setRowData(row);
                setOpenDrawer(!openDrawer);
              }}
            >
              {employeeName}
            </span>
          </SmartTooltip>
        );
      },
    },
    {
      key: "employeeID",
      label: "Employee ID",
      render: (row) => (
        <span>
          {getEmployeeId(
            row?.employeeId?.uiid,
            row?.employeeId?.employmentType,
          ) || "-"}
        </span>
      ),
    },
    {
      key: "employeeCategory",
      label: "Employee Category",
      render: (row) => <span>{row?.salaryProfileId?.name || "-"}</span>,
    },
    {
      key: "salaryType",
      label: "Salary Type",
      render: (row) => (
        <span>
          {row?.payConfigId?.lca?.type === 1
            ? "Monthly"
            : row?.payConfigId?.lca?.type === 2
              ? "Yearly"
              : "-" || "-"}
        </span>
      ),
    },
    {
      key: "lcaMonthly",
      label: "LCA Monthly",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.payConfigId?.lca?.type === 2
              ? row?.payConfigId?.lca?.wages / 12
              : row?.payConfigId?.lca?.wages,
          ) || "-"}
        </span>
      ),
    },
    {
      key: "timesheets",
      label: "Timesheets",
      render: (row) => (
        <span> {formatCurrency(row?.timesheets?.totalPay) || "-"}</span>
      ),
    },
    {
      key: "expenses",
      label: "Expenses",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.otherPays?.morePay
              ?.filter((item) =>
                item?.type?.toLowerCase().includes("commission"),
              )
              .reduce((sum, item) => sum + (item?.amount || 0), 0),
          ) || "-"}
        </span>
      ),
    },
    {
      key: "deductions",
      label: "Deductions",
      render: (row) => <span>{formatCurrency(row?.amounts?.diff) || "-"}</span>,
    },
    {
      key: "healthInsurance",
      label: "Health Insurance",
      render: (row) => (
        // <span>
        //   {formatCurrency(
        //     row?.deductions?.insurance?.ids?.installments?.find(
        //       (item) => item?.payrollId === row?.uiid
        //     )?.received
        //   ) || "-"}
        // </span>
        <span>{formatCurrency(row?.amounts?.insurance) || "-"}</span>
      ),
    },
    {
      key: "adjustmentPayments",
      label: "Adjustment Payments",
      render: (row) => {
        return <span className="">{"-"}</span>;
      },
    },

    {
      key: "perDiem",
      label: "Per Diem",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.otherPays?.morePay
              ?.filter((item) => item?.type?.toLowerCase().includes("per diem"))
              .reduce((sum, item) => sum + (item?.amount || 0), 0),
          ) || "-"}
        </span>
      ),
    },
    {
      key: "commision",
      label: "Other Payments",
      render: (row) => (
        <span>{formatCurrency(row?.otherPays?.totalAmt) || "-"}</span>
      ),
    },
    {
      key: "total",
      label: "Total",
      render: (row) => (
        <span> {formatCurrency(row?.amounts?.netPay) || "-"}</span>
      ),
    },

    {
      key: "action",
      label: "Action",
      sortable: false,
      render: (row) => (
        // pause, undo, visibility
        <div className="flex gap-1 z-50">
          <Button
            type="icon"
            variant="text"
            icon="visibility"
            size="sm"
            onClick={() => {
              setRowData(row);
              setOpenDrawer(!openDrawer);
            }}
          />
          {/* <ToolTip   description={"Finalize Employee"} tooltipPosition="left" size="xs-sm" noicon> */}
          <Button
            type="icon"
            variant="text"
            icon="undo"
            size="sm"
            onClick={() => handleRevertSingle(row.uiid, 1)}
          />
          {/* </ToolTip> */}

          <Button
            type="icon"
            variant="text"
            icon="pause"
            size="sm"
            onClick={() => handleRevertSingle(row.uiid, 3)}
          />
          <Button
            type="icon"
            variant="text"
            icon="attach_money"
            size="sm"
            onClick={() => handleRevertSingle(row.uiid, 4)}
          />
        </div>
      ),
    },
  ];
  const tableData2 = dataArray.map((item) => ({
      id: item.uiid,
      ...item,
    })) || [];
  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);

  const handleButtons = async (status = 1) => {
    try {
      if (!loginUserData?.employeeId) {
        showToast(
          "Only Employees can update the Payroll status",
          "error",
          3000,
        );
        return;
      }
      if (selectedRows.length === 0) {
        showToast("No Payrolls Selected To Revert", "info", 3000);
        return;
      }
      await Promise.all(
        selectedRows?.map((row) => {
          console.log({ ProposedEmployees, row });
          const netPay = ProposedEmployees?.data?.find(
            (item) => item.uiid === row,
          )?.amounts?.netPay;
          dispatch(
            updatePayrollStart({
              uiid: row,
              coll: "Payroll",
              customToast: "Payroll Paid Successfully",
              payload: [
                {
                  type: "SET",
                  value: {
                    // { $set: {status: 4, "amounts.paid": data.records.reduce((acc, record) => acc+=record.cost, 0)}, 'paymentInfo.on': new Date() }
                    status: status,
                    "amounts.paid": netPay,
                    ...(status === 4 && {
                      "paymentInfo.on": new Date().toISOString(),
                    }),
                  },
                },
              ],
              onSuccess: () => {
                setSelectedRows([]);
                fetchPayrolls();
              },
            }),
          );
        }),
      );
    } catch (error) {
      console.error("error in handleButtons", error);
    }
  };
  const handleRevertSingle = async (id, status) => {
    try {
      if (!id) {
        showToast("No Payroll Selected To Revert", "info", 3000);
        return;
      }

      dispatch(
        updatePayrollStart({
          uiid: id,
          coll: "Payroll",
          payload: [
            {
              type: "SET",
              value: {
                status: status,
                ...(status === 4 && {
                  paymentInfo: {
                    on: new Date().toISOString(),
                    paidBy: loginUserData?.uiid,
                  },
                }),
              },
            },
          ],
          customToast:
            status === 1
              ? "Payroll Moved To Proposed"
              : status === 3
                ? "Payroll Moved To Hold"
                : status === 4
                  ? "Payroll Paid Successfully"
                  : "Payroll Updated Successfully",
          onSuccess: () => {
            fetchPayrolls();
          },
        }),
      );
    } catch (error) {
      console.log("Error in handleRevertSingle:", error);
    }
  };
  // console.log("selectedRows", selectedRows);

  const handleQbSync = async (qbtype) => {
    try {
      if (selectedRows.length === 0) {
        showToast("No rows selected", "error", 3000);
        return;
      }
      let baseUrl = WORKFORCE_API_URL;
      for (const row of selectedRows) {
        const payrollDetails = ProposedEmployees?.data?.find(
          (item) => item.uiid === row,
        );
        if (!payrollDetails) {
          showToast(`No payroll details found for ${row}`, "error", 3000);
          continue;
        }
        const payrollPayload = {
          update: true,
          preActions: ["GetQBDoc"],
          skipMapping: true,
          payload: {
            employeeId: payrollDetails?.employeeId?.uiid,
            netPay: payrollDetails?.amounts?.netPay,
          },
        };
        const response = await axios.post(
          `${baseUrl}/qb/employees`,
          payrollPayload,
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          },
        );
        if (response.data.success) {
          showToast(`QB synced successfully for ${row}`, "success", 3000);
        } else {
          showToast(response.data.message, "error", 3000);
        }
      }
    } catch (error) {
      console.error(error);
      showToast(error.message, "error", 3000);
    }
  };

  const handleSelectChange = (data) => {
    setSelectedRows(data);
    //store all the sleectyed payerolls in an array
    //and manipulate and reduce to display the total payroll amount
    const totalAmount = ProposedEmployees?.data?.reduce((acc, row) => {
      if (data.includes(row.uiid)) {
        return acc + row.amounts.netPay;
      }
      return acc;
    }, 0);
    setTotalPayAmount(totalAmount);
    // console.log("totalAmount", totalAmount);
  };
  return (
    <>
      {totalPayAmount > 0 && (
        <div className="m-4">
          Total Payroll Amount: {formatCurrency(totalPayAmount)}
        </div>
      )}
      <TableAdv
        tableId={`payroll_upcomingpaydays_finalizedemployees`}
        // onSelectionChange={setSelectedRows}
        defaultSelectedRows={selectedRows}
        onSelectionChange={handleSelectChange}
        fixedCol={2}
        // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        showCheckbox
        rows={mappedRows}
        columns={columns}
        serverPagination={true}
        serverOnSearch={handleSearch}
        page={page}
        limit={limit}
        totalCount={totalCount}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: true,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className="flex gap-1 items-center">
                  <Button
                    title="Search"
                    size="sm"
                    onClick={() => handleButtons(1)}
                  />
                  <Button
                    title="Revert"
                    size="sm"
                    variant="outlined"
                    icon="undo"
                    onClick={() => handleButtons(1)}
                  />
                  <button
                    onClick={() => handleQbSync("payroll")}
                    className="mx-1"
                  >
                    <Avatar src={qb} alt={"qb"} size="xs" outline />
                  </button>
                  <Button
                    title={"Paid"}
                    size="sm"
                    variant="outlined"
                    // icon={"paid"}
                    // icon={"attach_money"}
                    onClick={() => handleButtons(4)}
                  />
                  <DropdownMenu
                    MenuSection={
                      <div className="flex flex-col">
                        <Button
                          title={"EXCEL"}
                          variant="text"
                          color="black"
                          size="xs-sm"
                          className="!justify-start py-1"
                        />
                        <Button
                          title={"CSV"}
                          variant="text"
                          color="black"
                          size="xs-sm"
                          className="!justify-start py-1"
                        />
                      </div>
                    }
                  >
                    <Button
                      color="black"
                      title=""
                      size="md"
                      icon={"screen_share"}
                      variant="text"
                    />
                  </DropdownMenu>
                </div>
              ),
            },
          ],
        }}
      />
      <div>
        <Drawer
          isOpen={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
            setRowData({});
            dispatch(clearCurrentPayrollEditing());
            fetchPayrolls();
          }}
          position="left" // 'left', 'right', 'top', 'bottom'
          width="w-[80%]" // custom width using Tailwind classes
          title=""
          closeOnOutsideClick
          showCloseButton={false}
          className="!p-0"
          bodyGap={false}
          hiden
        >
          <div>
            <ProposedEmployeesDetails
              // onHoldClick={() => {
              //   setOpenDrawer(false);
              //   setRowData({});
              // }}
              disableEditing={true}
              hideButtons={true}
              onHoldClick={() => {
                setOpenDrawer(false);
                setRowData({});
                dispatch(
                  getAllPayrollStart({
                    coll: "Payroll",
                    // useAggregate: true,
                    limit: limit,
                    page: page,
                    // ref: "Employee SalaryProfile",
                    // ref: "Employee SalProfile PayConfig Deduction",
                    ref: "Employee SalProfile PayConfig InsuranceDed RegularDed ShortPay ExcessPay",
                    filters: {
                      status: {
                        type: "NONE",
                        value: 2,
                      },
                      "payCycle.from": {
                        type: "GTE",
                        value: configData?.payCycle?.from,
                      },
                      "payCycle.to": {
                        type: "LTE",
                        value: configData?.payCycle?.to,
                      },
                      salaryProfileId: {
                        type: "NONE",
                        value: configData?.salaryProfileId?.uiid,
                      },
                    },
                  }),
                );
                dispatch(
                  totalCountStart({
                    collection: "payrolls",
                    coll: "Payroll",
                    filters: {
                      // status: {
                      //   type: "NONE",
                      //   value: 1,
                      // },
                      "payCycle.from": {
                        type: "GTE",
                        value: configData?.payCycle?.from,
                      },
                      "payCycle.to": {
                        type: "LTE",
                        value: configData?.payCycle?.to,
                      },
                      salaryProfileId: {
                        type: "NONE",
                        value: configData?.salaryProfileId?.uiid,
                      },
                    },
                    // ref:"SalaryProfile"
                  }),
                );
              }}
              rowData={rowData}
            />
          </div>
        </Drawer>
      </div>
      <FinalizeModal
        isOpen={FinalizeModalOpen}
        onClose={() => setFinalizeModalOpen(false)}
      />
    </>
  );
};

export default FinalizedEmployees;
